import {ApplicationSource} from "../../application/utils/form/application_form_source";
import {UnlockChoiceOptionId} from "../types/IUnlockChoiceOption";
import {UnlockChoiceEntryPoint} from "../types/UnlockChoiceEntryPoint";

interface IUnlockChoiceLeadSourceContext {
    entryPoint: UnlockChoiceEntryPoint;
    flowLeadSource?: ApplicationSource;
    propertyId?: number | null;
}

export const getUnlockChoiceLeadSource = (
    optionId: UnlockChoiceOptionId,
    {entryPoint, flowLeadSource, propertyId}: IUnlockChoiceLeadSourceContext
): ApplicationSource | null => {
    const isLeadEntryPoint = entryPoint === UnlockChoiceEntryPoint.LEAD;

    switch (optionId) {
        case "offer":
            return isLeadEntryPoint ? (flowLeadSource ?? null) : (flowLeadSource ?? ApplicationSource.PriceInquiry);
        case "reservation":
            return isLeadEntryPoint ? (flowLeadSource ?? null) : ApplicationSource.Reservation;
        case "meeting":
            return propertyId ? ApplicationSource.ApplicationPropertyScheduleMeeting : ApplicationSource.ApplicationOfferScheduleMeeting;
        case "full_package":
            return propertyId ? ApplicationSource.Property : ApplicationSource.Offer;
        case "content_only":
            return null;
    }
};
import {ApplicationSource} from "../../application/utils/form/application_form_source";
import {UnlockChoiceOptionId} from "../types/IUnlockChoiceOption";
import {UnlockChoiceEntryPoint} from "../types/UnlockChoiceEntryPoint";

interface IUnlockChoiceLeadSourceContext {
    entryPoint: UnlockChoiceEntryPoint;
    flowLeadSource?: ApplicationSource;
    propertyId?: number | null;
}

export const getUnlockChoiceLeadSource = (
    optionId: UnlockChoiceOptionId,
    {entryPoint, flowLeadSource, propertyId}: IUnlockChoiceLeadSourceContext
): ApplicationSource | null => {
    const isLeadEntryPoint = entryPoint === UnlockChoiceEntryPoint.LEAD;

    switch (optionId) {
        case "offer":
            return isLeadEntryPoint ? (flowLeadSource ?? null) : (flowLeadSource ?? ApplicationSource.PriceInquiry);
        case "reservation":
            return isLeadEntryPoint ? (flowLeadSource ?? null) : ApplicationSource.Reservation;
        case "meeting":
            return propertyId ? ApplicationSource.ApplicationPropertyScheduleMeeting : ApplicationSource.ApplicationOfferScheduleMeeting;
        case "full_package":
            return propertyId ? ApplicationSource.Property : ApplicationSource.Offer;
        case "content_only":
            return null;
    }
};
